import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { StudioHero } from '@/components/studio/studio-hero'
import { StudioCulture } from '@/components/studio/studio-culture'
import { StudioNumbers } from '@/components/studio/studio-numbers'
import { StudioTeam } from '@/components/studio/studio-team'
import { StudioPrinciples } from '@/components/studio/studio-principles'
import { StudioClients } from '@/components/studio/studio-clients'
import { StudioAwards } from '@/components/studio/studio-awards'
import { StudioJournal } from '@/components/studio/studio-journal'
import { StudioContact } from '@/components/studio/studio-contact'
import { media } from '@/constants/media'

const DESCRIPTION = 'A small brand and web studio in Los Angeles and Tokyo. Meet the four people behind the work, the principles we hold to, and the numbers that keep us honest.'

const Studio: FC = (): ReactNode => {
    return (
        <Layout theme='dark'>
            <Seo
                title='Studio'
                description={DESCRIPTION}
                ogImage={media.studioCulture}
            />

            <StudioHero />
            <StudioCulture />
            <StudioNumbers />
            <StudioTeam />
            <StudioPrinciples />
            <StudioClients />
            <StudioAwards />
            <StudioJournal />
            <StudioContact />
        </Layout>
    )
}

export default Studio
